// src/mocks/data/analyticsV2.demo.js

export const dailySalesProgress = {
    success: true,
    data: {
        current: { sales: 767048.32, invoiceCount: 41, hour: 13, minute: 30 },
        comparison: { sevenDayAverage: { sales: 667172.45 }, isAheadOfAverage: true, percentDiffVsAverage: 15.0 },
        goal: { progressPercent: 85.0, targetSales: 902410.96 },
        statistics: { performanceCategory: 'exceptional' },
        projection: { estimatedEndOfDayTotal: 1436000.00, willBeatGoal: true, differenceVsGoal: 533589.04, hoursRemaining: 4.5 },
    },
};

// ── Sales Summary ────────────────────────────────────────────────────────────
export const salesSummaryWeek = {
    success: true,
    data: {
        summary: { invoiceCount: 378, totalSales: 9895012.44, avgTicket: 26173.31 },
    },
};

export const salesSummaryMonth = {
    success: true,
    data: {
        summary: { invoiceCount: 2621, totalSales: 37046986.71, avgTicket: 14134.68 },
    },
};

export const salesSummary = salesSummaryMonth; // backward-compat alias

// ── Sales By Category ─────────────────────────────────────────────────────────
// Day: Tuesday Jan 13 2026 half-day — matches VENTAS HOY $767K / 41 facturas
// ART. PISCINAS leads (all the cloro/ácido pool products)
export const salesByCategoryDay = {
    success: true,
    data: {
        categories: [
            { category: 'ART. PISCINAS', totalRevenue: 267018.32, invoiceCount: 10, totalQuantity:  32, percentage: 34.8 },
            { category: 'FERRETERIA',    totalRevenue: 220012.00, invoiceCount: 12, totalQuantity:  68, percentage: 28.7 },
            { category: 'CERRAJERÍA',    totalRevenue:  98268.90, invoiceCount:  8, totalQuantity:  15, percentage: 12.8 },
            { category: 'ADHESIVOS',     totalRevenue:  68160.00, invoiceCount:  3, totalQuantity:  12, percentage:  8.9 },
            { category: 'PINTURAS',      totalRevenue:  52144.71, invoiceCount:  3, totalQuantity:   2, percentage:  6.8 },
            { category: 'HERRAMIENTAS',  totalRevenue:  38354.21, invoiceCount:  3, totalQuantity:   5, percentage:  5.0 },
            { category: 'Sin Categoría', totalRevenue:  23090.18, invoiceCount:  2, totalQuantity:   4, percentage:  3.0 },
        ],
    },
};

// Week: Jan 13–17 2026 — scaled 26.7 % of month; FERRETERIA dominates at 60.7 %
export const salesByCategoryWeek = {
    success: true,
    data: {
        categories: [
            { category: 'FERRETERIA',    totalRevenue: 6011038.09, invoiceCount: 526, totalQuantity: 5450, percentage: 60.7 },
            { category: 'Sin Categoría', totalRevenue:  518475.74, invoiceCount:  48, totalQuantity: 1303, percentage:  5.2 },
            { category: 'ELECTRICIDAD',  totalRevenue:  498581.75, invoiceCount:  87, totalQuantity:  397, percentage:  5.0 },
            { category: 'HERRAMIENTAS',  totalRevenue:  493075.41, invoiceCount:  44, totalQuantity:   75, percentage:  5.0 },
            { category: 'SANITARIOS',    totalRevenue:  421661.02, invoiceCount:  75, totalQuantity:  194, percentage:  4.3 },
            { category: 'ADHESIVOS',     totalRevenue:  299262.51, invoiceCount:  44, totalQuantity:   50, percentage:  3.0 },
            { category: 'PINTURAS',      totalRevenue:  291310.37, invoiceCount:  32, totalQuantity:   50, percentage:  2.9 },
            { category: 'AGROQUIMICOS',  totalRevenue:  273365.51, invoiceCount:  34, totalQuantity:   62, percentage:  2.8 },
            { category: 'CERRAJERÍA',    totalRevenue:  201437.29, invoiceCount:  13, totalQuantity:   28, percentage:  2.0 },
            { category: 'CONSTRUCCION',  totalRevenue:  139498.30, invoiceCount:  24, totalQuantity:   44, percentage:  1.4 },
            { category: 'ART. PISCINAS', totalRevenue:  126879.78, invoiceCount:  11, totalQuantity:   13, percentage:  1.3 },
            { category: 'BULONERÍA',     totalRevenue:  125457.90, invoiceCount:  17, totalQuantity: 2383, percentage:  1.3 },
            { category: 'ART. JARDÍN',   totalRevenue:   30687.93, invoiceCount:   3, totalQuantity:    4, percentage:  0.3 },
        ],
    },
};

// Month: January 2026 full month
export const salesByCategoryMonth = {
    success: true,
    data: {
        categories: [
            { category: 'FERRETERIA',    totalRevenue: 22506696.55, invoiceCount: 1970, totalQuantity: 20406, percentage: 60.8 },
            { category: 'Sin Categoría', totalRevenue:  1941204.88, invoiceCount:  180, totalQuantity:  4879, percentage:  5.2 },
            { category: 'ELECTRICIDAD',  totalRevenue:  1866492.39, invoiceCount:  326, totalQuantity:  1486, percentage:  5.0 },
            { category: 'HERRAMIENTAS',  totalRevenue:  1845867.06, invoiceCount:  163, totalQuantity:   281, percentage:  5.0 },
            { category: 'SANITARIOS',    totalRevenue:  1578788.03, invoiceCount:  282, totalQuantity:   725, percentage:  4.3 },
            { category: 'ADHESIVOS',     totalRevenue:  1120114.25, invoiceCount:  163, totalQuantity:   189, percentage:  3.0 },
            { category: 'PINTURAS',      totalRevenue:  1091053.42, invoiceCount:  121, totalQuantity:   186, percentage:  2.9 },
            { category: 'AGROQUIMICOS',  totalRevenue:  1023458.17, invoiceCount:  129, totalQuantity:   232, percentage:  2.8 },
            { category: 'CERRAJERÍA',    totalRevenue:   754163.28, invoiceCount:   50, totalQuantity:   105, percentage:  2.0 },
            { category: 'CONSTRUCCION',  totalRevenue:   522269.35, invoiceCount:   90, totalQuantity:   164, percentage:  1.4 },
            { category: 'ART. PISCINAS', totalRevenue:   474953.69, invoiceCount:   41, totalQuantity:    50, percentage:  1.3 },
            { category: 'BULONERÍA',     totalRevenue:   469630.12, invoiceCount:   63, totalQuantity:  8923, percentage:  1.3 },
            { category: 'ART. JARDÍN',   totalRevenue:   114897.27, invoiceCount:   12, totalQuantity:    14, percentage:  0.3 },
        ],
    },
};

export const salesByCategory = salesByCategoryMonth; // backward-compat alias

// ── Payment Methods ───────────────────────────────────────────────────────────
// Day: matches VENTAS HOY $767,048 / 41 facturas — Contado dominates at 65 %
export const paymentMethodsDay = {
    success: true,
    data: {
        paymentMethods: [
            { name: 'Contado',             code: '201', totalAmount: 498581.41, count: 28, percentage: 65.0 },
            { name: 'Transferencia Banc.', code: '207', totalAmount: 161080.15, count:  9, percentage: 21.0 },
            { name: 'Tarjeta Débito',      code: '202', totalAmount:  61363.86, count:  3, percentage:  8.0 },
            { name: 'Tarjeta Crédito',     code: '203', totalAmount:  46022.90, count:  1, percentage:  6.0 },
        ],
        totalSales: 767048.32,
    },
};

// Week: Jan 13–17 2026 — scaled 26.7 % of month; multi-method split
export const paymentMethodsWeek = {
    success: true,
    data: {
        paymentMethods: [
            { name: 'Efectivo',            code: '201', totalAmount: 4363238.00, count: 375, percentage: 44.1 },
            { name: 'Transferencia Banc.', code: '207', totalAmount: 3120554.00, count: 216, percentage: 31.5 },
            { name: 'Cheque',              code: '202', totalAmount: 1527625.00, count:  91, percentage: 15.4 },
            { name: 'Cta. Corriente',      code: '203', totalAmount:  517987.00, count:  14, percentage:  5.2 },
            { name: 'Cta. Cte. Banco',     code: '204', totalAmount:  269483.00, count:   2, percentage:  2.7 },
            { name: 'Otra',                code: '208', totalAmount:   91014.00, count:   2, percentage:  0.9 },
            { name: 'Tarjeta Débito',      code: '205', totalAmount:    3435.00, count:   1, percentage:  0.0 },
        ],
        totalSales: 9893336.00,
    },
};

// Month: January 2026 full month
export const paymentMethodsMonth = {
    success: true,
    data: {
        paymentMethods: [
            { name: 'Efectivo',            code: '201', totalAmount: 16341709.72, count: 1405, percentage: 44.1 },
            { name: 'Transferencia Banc.', code: '207', totalAmount: 11684873.74, count:  807, percentage: 31.5 },
            { name: 'Cheque',              code: '202', totalAmount:  5719281.73, count:  342, percentage: 15.4 },
            { name: 'Cta. Corriente',      code: '203', totalAmount:  1938966.36, count:   51, percentage:  5.2 },
            { name: 'Cta. Cte. Banco',     code: '204', totalAmount:  1008545.70, count:    8, percentage:  2.7 },
            { name: 'Otra',                code: '208', totalAmount:   340750.11, count:    7, percentage:  0.9 },
            { name: 'Tarjeta Débito',      code: '205', totalAmount:    12859.35, count:    1, percentage:  0.0 },
        ],
        totalSales: 37046986.71,
    },
};

export const paymentMethods = paymentMethodsMonth; // backward-compat alias

// Profit Analysis — January 2026 full month
// Scaled ×2.245 from production April 2026 screenshot to match demo $37M totalRevenue
export const profitAnalysis = {
    success: true,
    data: {
        totalRevenue: 37042210,
        totalSales: 33483969,
        totalCost: 25030349,
        totalNetProfit: 8453620,
        totalTotalProfit: 8453620,
        totalIVACollected: 7031923,
        totalDiscountsApplied: 3473682,
        profitMargin: 25.25,
        avgTicket: 14133.62,
        invoicesByType: [
            {
                tipoComprobante: 'FACTURA A',
                invoiceCount: 80,
                totalSales: 1649917,
                totalRevenue: 1836210,
                netProfitWithoutIVA: 415040,
                ivaCollected: 346376,
                totalProfit: 415040,
                totalDiscountApplied: 160083,
            },
            {
                tipoComprobante: 'FACTURA B',
                invoiceCount: 1317,
                totalSales: 19627381,
                totalRevenue: 21636741,
                netProfitWithoutIVA: 5089654,
                ivaCollected: 4121744,
                totalProfit: 5089654,
                totalDiscountApplied: 2112384,
            },
            {
                tipoComprobante: 'PRESUPUESTO',
                invoiceCount: 1224,
                totalSales: 12206671,
                totalRevenue: 13569259,
                netProfitWithoutIVA: 2948926,
                ivaCollected: 2563803,
                totalProfit: 2948926,
                totalDiscountApplied: 1201215,
            },
        ],
        estimatedCostInfo: {
            invoicesWithEstimatedCost: 943,
            salesWithEstimatedCost: 9630800,
        },
        creditNotes: {
            amount: 387891,
            count: 34,
        },
    },
};
